import React, { FC, useState, useEffect } from "react"

interface FiltersProps {
  onFilterChange?: (filters: {
    dateFrom?: string
    dateTo?: string
    timeSlot?: string
  }) => void
}

const Filters: FC<FiltersProps> = ({ onFilterChange }) => {
  // YYYY-MM-DD形式に変換（input type="date"用）
  const formatDate = (date: Date): string => {
    return date.toISOString().substring(0, 10)
  }
  
  const today = new Date()
  const [dateFrom, setDateFrom] = useState(formatDate(today))
  const [dateTo, setDateTo] = useState(() => {
    const date = new Date(today)
    date.setDate(date.getDate() + 30)
    return formatDate(date)
  })
  const [activeTimeSlot, setActiveTimeSlot] = useState<string>('')

  // 初期化時にデフォルト期間を親コンポーネントに通知
  useEffect(() => {
    onFilterChange?.({
      dateFrom,
      dateTo,
      timeSlot: activeTimeSlot
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // 初回レンダリング時のみ実行

  const timeSlots = [
    { key: 'morning', label: '9:00～11:00' },
    { key: 'midday', label: '11:00～12:00' },
    { key: 'afternoon', label: '13:00～15:00' },
    { key: 'evening', label: '15:00～17:00' }
  ]

  const handleDateChange = (field: 'from' | 'to', value: string) => {
    if (field === 'from') {
      setDateFrom(value)
    } else {
      setDateTo(value)
    }
    onFilterChange?.({
      dateFrom: field === 'from' ? value : dateFrom,
      dateTo: field === 'to' ? value : dateTo,
      timeSlot: activeTimeSlot
    })
  }

  const handleTimeSlotClick = (slot: string) => {
    const newSlot = activeTimeSlot === slot ? '' : slot
    setActiveTimeSlot(newSlot)
    onFilterChange?.({
      dateFrom,
      dateTo,
      timeSlot: newSlot
    })
  }

  return (
    <section className="bg-white rounded-xl shadow border border-gray-200 overflow-hidden mb-8">
      <div className="p-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-xl font-semibold text-gray-900 m-0">フィルター</h3>
      </div>
      <div className="p-6">
        <div className="flex gap-6 items-center flex-wrap mb-4">
          <div className="flex gap-3 items-center">
            <label htmlFor="dateFrom" className="font-medium">予約日：</label>
            <input
              type="date"
              id="dateFrom"
              value={dateFrom}
              onChange={(e) => handleDateChange('from', e.target.value)}
              className="px-3 py-3 border border-gray-200 rounded-lg text-sm transition-all focus:outline-none focus:border-primary focus:ring-3 focus:ring-primary/10"
            />
            <span>〜</span>
            <input
              type="date"
              id="dateTo"
              value={dateTo}
              onChange={(e) => handleDateChange('to', e.target.value)}
              className="px-3 py-3 border border-gray-200 rounded-lg text-sm transition-all focus:outline-none focus:border-primary focus:ring-3 focus:ring-primary/10"
            />
          </div>
        </div>
        
        <div className="flex gap-6 items-center flex-wrap">
          <span className="font-medium">時間帯：</span>
          <div className="flex gap-2 flex-wrap">
            {timeSlots.map((slot) => (
              <button
                key={slot.key}
                className={`px-4 py-2 border rounded-xl cursor-pointer transition-all text-sm font-medium ${
                  activeTimeSlot === slot.key
                    ? 'bg-primary text-white border-primary'
                    : 'border-gray-200 bg-white hover:border-primary hover:bg-primary-light/10'
                }`}
                onClick={() => handleTimeSlotClick(slot.key)}
              >
                {slot.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Filters

